import { render } from "./letter-delete.vue?vue&type=template&id=25756c6f"
import script from "./letter-delete.vue?vue&type=script&lang=js"
export * from "./letter-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__